import moment from "moment";

export const relanceAvaillable = (ticket) => {
    const now = new Date();
    const unJourEnMs = 24 * 60 * 60 * 1000;

    if ((ticket?.intervention?.length ?? 0) <= 0) {
        return true;
    }

    return !(ticket.intervention ?? []).some(inter => {
        if (inter.description?.includes("RELANCE")) {
            const derniereModification = moment(inter.date, "YYYY-MM-DD HH:mm:ss").toDate();
            const diffTemps = now - derniereModification;
            
            return diffTemps < unJourEnMs; // Si moins d'un jour, on bloque
        }
        return false;
    });
};